export enum Routes {
  home = "/home",
  login = "/login",
  signup = "/signup",
  linkAccounts = "/link-account",
  userActivity = "/user-activity",
  consent = "/consent",
  account = "/account",
  grievance = "/user-grievance",
  terms = "/terms",
  privacy = "/privacy",
  webview = "/webview",
  redirected = "/redirected",
}

export enum QueryParams {
  redirect = "redirect",
  entityId = "entityId",
  entityType = "entityType",
  fipId = "fipId",
}

export enum AcitivityTypes {
  account = "Account",
  consent = "Consent",
}
